/**
 * Human-readable detail from a failed API call. The server's error envelope
 * puts its message at `response.data.error`; this is the one place that
 * shape is known on the client.
 */
export function apiErrorDetail(error: any): string {
  return error?.response?.data?.error ?? error?.message ?? 'Unknown error';
}
